<!-- Spinner -->

<!-- Content -->
@if (question && trainingResult && trainingResult.answer !== undefined) {
  <!-- Header -->
  <medsurf-quiz-question-header [index]="((trainingSharedFacade.quizActive$ | async) ? undefined : question.customEnumeration) || (((trainingSharedFacade.selectedQuestionIndex$(question.id) | async) || index) + 1).toString()"
    [checkedAndCorrect]="trainingResult.showFeedback && isCorrect()"
    [questionType]="question.type">
  </medsurf-quiz-question-header>
  <!-- Question Form -->
  <form name="form"
    class="mdsf-quiz-form">
    <!-- Question Text -->
    <medsurf-text [text]="question.content"></medsurf-text>
    <!-- Choices -->
    @if ((trainingSharedFacade.typedQuestionChoicesOrder$ | async); as typedQuestionChoicesOrder) {
      @if ((trainingSharedFacade.choicesByIds$(typedQuestionChoicesOrder[question.id] || []) | async); as choices) {
        @if (choices.length > 5 && (menuSharedFacade.showPrint$ | async) === false) {
          <div class="mb-4"
            >
            <div class="mb-0 border-0 mt-0">
              <div class="choice w-100 p-2"
                [class.choice-error]="trainingResult.showFeedback && question.solution !== trainingResult.answer"
                [class.choice-correct]="trainingResult.showFeedback && question.solution === trainingResult.answer"
                [class.choice-not-answered]="showRequired && trainingResult.showFeedback === false">
                <div class="flex-grow-1">
                  <!-- User Answer -->
                  <select class="form-control custom-select"
                    [ngModel]="trainingResult.answer"
                    [name]="'item' + question.order + 'set'"
                    [class.not-answered]="showRequired && trainingResult.showFeedback === false"
                    [required]="question.required"
                    [disabled]="trainingResult.showFeedback"
                    (blur)="onBlur($event.target.value)">
                    <option value="" disabled selected hidden>{{ question.placeholder }}</option>
                    @for (choice of choices; track choice; let k = $index) {
                      <option
                        [value]="choice.order" [innerHTML]="choice.label | stripTags">
                      </option>
                    }
                  </select>
                  <!-- Correct Answer -->
                  @if (trainingResult.showFeedback && question.solution !== trainingResult.answer && getChoiceBySolution(choices, question.solution); as choiceSolution) {
                    <div class="correct-answer mt-2"
                      >
                      <strong>{{ 'correct_answer' | translate }}:</strong> {{ choiceSolution.label | stripTags }}
                    </div>
                  }
                </div>
                <!-- Feedback -->
                @if (trainingResult.showFeedback) {
                  <div class="form-control-feedback mt-2 ml-2"
                    [class.invisible]="trainingResult.showFeedback === false || trainingResult.answer === ''">
                    @if (question.solution === trainingResult.answer) {
                      <i class="fa fa-fw fa-check solution-correct"
                      ></i>
                    }
                    @if (question.solution !== trainingResult.answer) {
                      <i class="fa fa-fw fa-times solution-error"
                      ></i>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- Choices Print Mode -->
        @if (choices.length <= 5 || (menuSharedFacade.showPrint$ | async)) {
          <div class="mb-4"
            >
            @for (choice of choices; track choice; let j = $index) {
              @if (choice?.label) {
                <div class="choice"
                  [ngStyle]="{'order': choice.order}"
                  [class.choice-selected]="choice.order === trainingResult.answer || (choice.order === question.solution && (menuSharedFacade.showPrintForAuthor$ | async))"
                  [class.choice-error]="trainingResult.showFeedback && choice.order === trainingResult.answer && question.solution !== trainingResult.answer"
                  [class.choice-correct]="trainingResult.showFeedback && choice.order === trainingResult.answer && question.solution === trainingResult.answer"
                  [class.no-hover]="trainingResult.showFeedback"
                  (click)="onClick(choice)">
                  <button type="button"
                    class="radio-custom"
                    id="choices{{choice.order}}"
                    name="choices{{choice.order}}">
                  </button>
                  <div
                    class="radio-custom-label"
                    [class.radio-custom-label-error]="trainingResult.showFeedback && choice.order === trainingResult.answer && question.solution !== trainingResult.answer"
                    [class.radio-custom-label-correct]="trainingResult.showFeedback && choice.order !== trainingResult.answer && question.solution === choice.order">
                    @if ((trainingResult.showFeedback && choice.order === trainingResult.answer && question.solution !== trainingResult.answer)) {
                      <i
                        class="fal fa-times cross">
                      </i>
                    }
                  </div>
                  <div class="choice-label">
                    <label class="choice-label-character">{{ trainingSharedFacade.helperListCharacter(question.numberingType, j) }}</label>
                    <label class="choice-label-text">
                      <medsurf-text [text]="choice.label"></medsurf-text>
                    </label>
                  </div>
                </div>
              }
            }
          </div>
        }
      } @else {
        <div class="d-flex justify-content-center m-2">
          <div class="spinner-border"></div>
        </div>
      }
    }
    <!-- Explanation -->
    @if (question.explanation && (trainingResult.showExplanation || (menuSharedFacade.showPrintForAuthor$ | async))) {
      <div class="form-control-explanation mt-2"
        >
        <strong>{{ 'explanation' | translate }}</strong>
        <medsurf-text [text]="question.explanation"></medsurf-text>
      </div>
    }
    <!-- Footer -->
    @if ((menuSharedFacade.showPrint$ | async) === false && question?.solution !== null) {
      <medsurf-quiz-question-footer #footer
        class="mt-2"
        [question]="question"
        [trainingResult]="trainingResult"
        [isCorrect]="isCorrect"
        [passRequired]="passRequired"
        [(showRequired)]="showRequired"
        [ngStyle]="{'order': 100}">
      </medsurf-quiz-question-footer>
    }
  </form>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
